import { useEffect } from 'react';
import { autorun } from 'mobx';
import * as Sentry from '@sentry/browser';

import { useStores } from '../hooks/useStores';

const SentryComponent = () => {
  const { user } = useStores();

  useEffect(() => {
    Sentry.init({
      release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
      dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
      environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
      enabled: process.env.NODE_ENV === 'production',
    });
  }, []);

  useEffect(() => {
    return autorun(() => {
      if (user && user.email) {
        Sentry.configureScope((scope) => {
          scope.setUser({
            email: user.email,
          });
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default SentryComponent;
